import store from './store/index.js';

export default function auth({ next }) {
     store.dispatch('checkAuth');
    if (!store.getters.auth.loggedIn) {
        return next({
            path: '/'
        });
    }
    return next();
}